/**
 * Holds CSS value definitions
 */
export enum CssDisplayMode {
    Browser = 'browser',
    Fullscreen = 'fullscreen',
    MinimalUi = 'minimal-ui',
    Standalone = 'standalone',
}
